module.exports = __webpack_public_path__ + "8e6e5762f8bf5cc2983b2e4137cd7f78.pdf";